import { createContext } from "react";

// Context shared between EditContent and the editor panel components.
// Provides content labels (for \ref links), support items, and undo/redo.
// Safe to consume anywhere — defaults to empty arrays / no-ops when no Provider is present.
export const EditCtx = createContext({
  contentLabels: [],
  supportItems: [],
  onUndo: null,
  onRedo: null,
});
